module.exports = __webpack_public_path__ + "img/historia3.72c712fc.jpg";